import AddTaskIcon from "@mui/icons-material/AddTask";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  Autocomplete,
  CircularProgress,
  FormHelperText,
  IconButton,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import React, { useEffect, useState } from "react";
import {
  ATTACHMENT_URL,
  GET_PRIORITY_BY_URGENCY_IMPACT_URL,
  IMPACTS_URL,
  PRIORITIES_URL,
  REQUEST_TYPE_URL,
  SOURCE_TYPES_URL,
  TICKET_CATEGORIES_URL,
  TICKET_URL,
  URGENCIES_URL,
  USERS_SEARCH_URL,
} from "../../Constants/Constants";
import { STATUS_SEQ_ID } from "../../Constants/StatusConstants";
import AxiosInstance from "../../services/AxiosInstance";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import { useAlert } from "./../alerts//AlertContext";
import { hasRole } from "../../auth/authService";
import { ROLE_ADMIN } from "../../Constants/RolesConstants";
import { isEmpty } from "../../Constants/RolesConstants";
import SaveIcon from "@mui/icons-material/Save";

function TicketDialog({ callTickets, componentPermissions, openDialog,
  onClose }) {
  const [subject, setSubject] = useState("");
  const [urgencyId, setUrgencyId] = useState("");
  const [urgencies, setUrgencies] = useState([]);

  const [categoryId, setCategoryId] = useState("");
  const [categories, setCategories] = useState([]);

  const [impactId, setImpactId] = useState("");
  const [impacts, setImpacts] = useState([]);

  const [priorityId, setPriorityId] = useState("");
  const [priorities, setPriorities] = useState([]);

  const [sourceTypeId, setSourceTypeId] = useState("");
  const [sourceTypes, setSourceTypes] = useState([]);

  const [description, setDescription] = useState("");

  const [requestTypeId, setRequestTypeId] = useState("");
  const [requestTypes, setRequestTypes] = useState([]);

  const [error, setError] = useState(false);

  // onBehlfof user fetching
  const [onBehalfOfUsers, setOnBehalfOfUsers] = useState([]);
  const [searchUser, setSearchUser] = useState("");
  const [searchUserValue, setSearchUserValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const [formData, setFormData] = useState({
    subject: "",
    description: "",
    requestType: "",
    category: "",
    urgency: "",
    impact: "",
    sourceType: "",
  });

  const [formErrors, setFormErrors] = useState({
    subject: "",
    description: "",
    requestType: "",
    category: "",
    urgency: "",
    impact: "",
    sourceType: "",
  });

  const [ticket, setTicket] = useState({
    subject: "",
    description: "",
    requestType: {},
    urgency: {},
    impact: {},
    priority: {},
    user: {},
    status: {},
    beHalfOfUser: {},
    ticketCategory: {},
    sourceType: {},
    //attachments: {}
  });

  const [files, setFiles] = useState([]);

  const [open, setOpen] = useState(false);

  const handleFormData = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    const errors = {};

    if (!formData.subject.trim()) errors.subject = "Subject is required";
    if (!formData.description.trim())
      errors.description = "Description is required";
    if (!formData.requestType) errors.requestType = "Request Type is required";
    if (!formData.category) errors.category = "Category is required";
    if (!formData.urgency) errors.urgency = "Urgency is required";
    if (!formData.impact) errors.impact = "Impact is required";
    if (!formData.sourceType) errors.sourceType = "Source Type is required";

    return errors;
  };

  useEffect(() => {
    if(openDialog) {
      setOpen(true);
      initializeSysValues();
    }

    if (!searchUser) {
      setOnBehalfOfUsers([]);
      return;
    }

    const fetch = async () => {
      setLoading(true);
      try {
        AxiosInstance.get(USERS_SEARCH_URL + searchUser).then((response) =>
          setOnBehalfOfUsers(response.data)
        );
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };

    const timer = setTimeout(() => {
      fetch();
    }, 300); // debounce: 300ms

    return () => clearTimeout(timer);
  }, [searchUser, openDialog]);

  const showAlert = useAlert();

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const handleClickOpen = () => {
    setOpen(true);
    initializeSysValues();
  };

  const handleClose = () => {
    setOpen(false);
     if (onClose) {
        onClose();
    }
  };

  const handleSubjectChange = (event) => {
    setSubject(event.target.value);
    handleFormData(event);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
    handleFormData(event);
  };

  const handleRequestTypeChange = (event) => {
    setRequestTypeId(event.target.value);
    handleFormData(event);
  };

  const handleUrgencyChange = (event) => {
    setUrgencyId(event.target.value);
    if (
      event.target.value !== null &&
      event.target.value !== "" &&
      impactId !== null &&
      impactId !== ""
    ) {
      getPriorityByUrgencyAndImpact(event.target.value, impactId);
    }
    handleFormData(event);
  };

  const handleCategoryChange = (event) => {
    setCategoryId(event.target.value);
    handleFormData(event);
  };

  const handleImpactChange = (event) => {
    setImpactId(event.target.value);
    if (
      event.target.value !== null &&
      event.target.value !== "" &&
      urgencyId !== null &&
      urgencyId !== ""
    ) {
      getPriorityByUrgencyAndImpact(urgencyId, event.target.value);
    }
    handleFormData(event);
  };

  const handlePriorityChange = (event) => {
    setPriorityId(event.target.value);
  };

  const handleSourceTypeChange = (event) => {
    setSourceTypeId(event.target.value);
    handleFormData(event);
  };

  const getPriorityByUrgencyAndImpact = (urgencyId, impactId) => {
    AxiosInstance.get(GET_PRIORITY_BY_URGENCY_IMPACT_URL, {
      params: { urgencyId: urgencyId, impactId: impactId },
    }).then((response) => {
      console.log(response.data);
      setPriorityId(response.data.priority.id);
    });
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    setFiles(selectedFiles);
  };

  const removeFile = (index) => {
    setFiles(files.filter((_, i) => i !== index));
  };

  const initializeSysValues = () => {
    AxiosInstance.get(SOURCE_TYPES_URL).then((response) =>
      setSourceTypes(response.data)
    );
    AxiosInstance.get(TICKET_CATEGORIES_URL).then((response) =>
      setCategories(response.data.data)
    );
    AxiosInstance.get(URGENCIES_URL).then((response) =>
      setUrgencies(response.data)
    );
    AxiosInstance.get(IMPACTS_URL).then((response) =>
      setImpacts(response.data)
    );
    AxiosInstance.get(PRIORITIES_URL).then((response) =>
      setPriorities(response.data.data)
    );
    AxiosInstance.get(REQUEST_TYPE_URL).then((response) =>
      setRequestTypes(response.data)
    );
  };
  const saveTicket = () => {
    const errors = validate();

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
    } else {
      setError(false);

      ticket.subject = subject;
      ticket.description = description;
      ticket.requestType = { id: requestTypeId };
      ticket.urgency = { id: urgencyId };
      ticket.impact = { id: impactId };
      ticket.priority = { id: priorityId };
      ticket.user = { id: localStorage.getItem("id") };
      ticket.status = { seq: STATUS_SEQ_ID };
      if (searchUserValue?.id != "" && searchUserValue?.id != null)
        ticket.beHalfOfUser = { id: searchUserValue?.id };
      ticket.ticketCategory = { id: categoryId };
      ticket.sourceType = { id: sourceTypeId };
      //alert(searchUserValue.id);

      AxiosInstance.post(TICKET_URL, ticket)
        .then((response) => {
          handleUpload(response.data.id);
          //alert("Ticket created successfully!");
          showAlert("Ticket created successfully!", "success");
          callTickets();
        })
        .catch((error) => {
          alert("Ticket creation failed!");
          console.error(error);
        });
      handleClose();
    }
  };

  const handleUpload = async (ticketId) => {
    if (files) {
      [...files].forEach((file) => {
        let attachmentData = new FormData();
        attachmentData.append("file", file);
        attachmentData.append("ticketId", ticketId);
        AxiosInstance.post(ATTACHMENT_URL, attachmentData, {
          ...(AxiosInstance.defaults.headers["Content-Type"] =
            "multipart/form-data"),
        })
          .then((response) => {
            console.log("Attachment saved successfully");
          })
          .catch((error) => {
            alert("Save attachment failed!");
            console.error(error);
          });
      });
    }
  };
  return (
    <ThemeProvider>
      <React.Fragment>
        {/* <Button variant="outlined" onClick={handleClickOpen} style={{float:"right", margin:"2px"}}>
              Add Ticket
              </Button> */}
        {isEmpty(componentPermissions) ||
          componentPermissions?.["canCreate"] ? (
          <Tooltip
            title="Add Ticket"
            onClick={handleClickOpen}
            style={{ cursor: "pointer", margin: "2px" }}
          >
            <IconButton>
              <AddTaskIcon color="primary" />
            </IconButton>
          </Tooltip>
        ) : null}

        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              saveTicket();
            },
            sx: {
              width: 600, // fixed width
              height: 720, // fixed height
              maxWidth: "100%", // optional for responsiveness
              maxHeight: "100%", // optional to prevent overflow
            },
          }}
        >
          <DialogTitle>Add Ticket</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              sx={{ "& .MuiTextField-root": { m: 1, width: "95%" } }}
              noValidate
              autoComplete="off"
            >
              {hasRole([ROLE_ADMIN]) && (
                <Autocomplete
                  open={searchOpen}
                  onOpen={() => setSearchOpen(true)}
                  onClose={() => setSearchOpen(false)}
                  getOptionLabel={(option) => option.name || ""}
                  options={onBehalfOfUsers}
                  loading={loading}
                  id="outlined-multiline-static"
                  onInputChange={(event, newInputValue) => {
                    setSearchUser(newInputValue);
                  }}
                  value={searchUserValue}
                  onChange={(event, newValue) => {
                    setSearchUserValue(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      id="outlined-multiline-static"
                      {...params}
                      label="On Behalf Of"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {loading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              )}

              <TextField
                autoFocus
                fullWidth
                required
                margin="dense"
                id="outlined-multiline-static"
                name="subject"
                label="Subject"
                type="text"
                variant="outlined"
                value={formData.subject}
                error={!!formErrors.subject}
                helperText={formErrors.subject}
                onChange={handleSubjectChange}
              />
              <br />
              <TextField
                autoFocus
                id="outlined-multiline-static"
                name="description"
                label="Description"
                placeholder="Description"
                fullWidth
                multiline
                rows={4}
                cols={10}
                required
                value={formData.description}
                error={!!formErrors.description}
                helperText={formErrors.description}
                onChange={handleDescriptionChange}
              />
              <br />
              <FormControl
                variant="outlined"
                sx={{ m: 1, minWidth: "47%" }}
                required
                error={Boolean(formErrors.requestType)}
              >
                <InputLabel id="demo-simple-select-standard-label">
                  Request Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  name="requestType"
                  // value={requestTypeId}
                  value={formData.requestType}
                  onChange={handleRequestTypeChange}
                  label="Request Type"
                >
                  {requestTypes.map((rt) => (
                    <MenuItem value={rt.id}>{rt.name}</MenuItem>
                  ))}
                </Select>
                {error && (
                  <FormHelperText>{formErrors.requestType}</FormHelperText>
                )}
              </FormControl>
              <FormControl
                variant="outlined"
                sx={{ m: 1, minWidth: "46%" }}
                required
                error={Boolean(formErrors.category)}
              >
                <InputLabel id="demo-simple-select-standard-label">
                  Category
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  name="category"
                  //value={categoryId}
                  value={formData.category}
                  onChange={handleCategoryChange}
                  label="Category"
                >
                  {categories.map((cat) => (
                    <MenuItem value={cat.id}>{cat.name}</MenuItem>
                  ))}
                </Select>
                {error && (
                  <FormHelperText>{formErrors.category}</FormHelperText>
                )}
              </FormControl>
              <br />
              <FormControl
                variant="outlined"
                sx={{ m: 1, minWidth: "47%" }}
                required
                error={Boolean(formErrors.urgency)}
              >
                <InputLabel id="demo-simple-select-standard-label">
                  Urgency
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={formData.urgency}
                  name="urgency"
                  onChange={handleUrgencyChange}
                  label="Urgency"
                >
                  {urgencies.map((urgency) => (
                    <MenuItem value={urgency.id}>{urgency.name}</MenuItem>
                  ))}
                </Select>
                {error && <FormHelperText>{formErrors.urgency}</FormHelperText>}
              </FormControl>

              <FormControl
                variant="outlined"
                sx={{ m: 1, minWidth: "46%" }}
                required
                error={Boolean(formErrors.impact)}
              >
                <InputLabel id="demo-simple-select-standard-label">
                  Impact
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={formData.impact}
                  name="impact"
                  onChange={handleImpactChange}
                  label="Impact"
                >
                  {impacts.map((imp) => (
                    <MenuItem value={imp.id}>{imp.name}</MenuItem>
                  ))}
                </Select>
                {error && <FormHelperText>{formErrors.impact}</FormHelperText>}
              </FormControl>
              <br />
              <FormControl variant="outlined" sx={{ m: 1, minWidth: "47%" }}>
                <InputLabel id="demo-simple-select-standard-label">
                  Priority
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={priorityId}
                  onChange={handlePriorityChange}
                  label="Priority"
                  disabled
                >
                  {priorities.map((prty) => (
                    <MenuItem value={prty.id}>{prty.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl
                variant="outlined"
                sx={{ m: 1, minWidth: "46%" }}
                required
                error={Boolean(formErrors.sourceType)}
              >
                <InputLabel id="demo-simple-select-standard-label">
                  Source Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={formData.sourceType}
                  onChange={handleSourceTypeChange}
                  label="Source Type"
                  name="sourceType"
                >
                  {sourceTypes.map((src) => (
                    <MenuItem value={src.id}>{src.name}</MenuItem>
                  ))}
                </Select>
                {error && (
                  <FormHelperText>{formErrors.sourceType}</FormHelperText>
                )}
              </FormControl>
              <br />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, m: 1, }}>
                <Button
                  component="label"
                  role={undefined}
                  variant="contained"
                  tabIndex={-1}
                  startIcon={<CloudUploadIcon />}
                  sx={{
                    minWidth: 200,
                  }}
                >
                  Upload files
                  <VisuallyHiddenInput
                    type="file"
                    onChange={handleFileChange}
                    multiple
                  />
                </Button>
                {files.length > 0 && (
                  <div>
                    {/* <h5>Selected files:</h5> */}
                    <ul>
                      {files.map((file, index) => (
                        <li key={index}>
                          <span>{file.name}</span>&nbsp;&nbsp;
                          <CloseIcon
                            style={{ cursor: "pointer" }}
                            onClick={() => removeFile(index)}
                          />
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </Box>
            </Box>
          </DialogContent>
          <DialogActions sx={{ marginBottom: "20px" }}>
            {/* <Button onClick={handleClose}>Cancel</Button> */}
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
              sx={{
                float: "right",
                minWidth: 150,
                marginRight: "25px",
                marginTop: "10px",
                background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
                boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
                "&:hover": {
                  background: "linear-gradient(45deg, #1565c0 30%, #1976d2 90%)",
                },
              }}>Add </Button>

          </DialogActions>
        </Dialog>
      </React.Fragment>
    </ThemeProvider>
  );
}
export default TicketDialog;
